module.exports = __webpack_public_path__ + "static/media/notificationUnread.a79045e2.svg";